import InvoiceList from './InvoiceList';

export default InvoiceList;
